import React from 'react';
import type { FC, SVGProps } from 'react';
import {
  CaregivingIcon as CaregivingIconSvg,
  FaithIcon as FaithIconSvg,
  FinancesIcon as FinancesIconSvg,
  FinancesIconTag as FinancesIconTagSvg,
  GriefIcon as GriefIconSvg,
  IdentityIcon as IdentityIconSvg,
  MedicalIcon as MedicalIconSvg,
  OverwhelmIcon as OverwhelmIconSvg,
  RelationshipsIcon as RelationshipsIconSvg,
  SchoolIcon as SchoolIconSvg,
  WorkIcon as WorkIconSvg,
} from './icons';

interface TopicIconProps {
  isSelected?: boolean;
}

const ICON_SIZE = 24;
const ICON_CLASS = 'size-6 shrink-0';

function createTopicIcon(Icon: FC<SVGProps<SVGSVGElement>>): React.FC<TopicIconProps> {
  return function TopicIcon({ isSelected = false }) {
    const colorClass = isSelected ? 'text-accent' : 'text-primary';
    return (
      <span className={`inline-flex ${colorClass}`} aria-hidden>
        <Icon width={ICON_SIZE} height={ICON_SIZE} className={ICON_CLASS} />
      </span>
    );
  };
}

export const RelationshipsIcon = createTopicIcon(RelationshipsIconSvg);
export const GriefIcon = createTopicIcon(GriefIconSvg);
export const IdentityIcon = createTopicIcon(IdentityIconSvg);
export const WorkIcon = createTopicIcon(WorkIconSvg);
export const FinancesIcon = createTopicIcon(FinancesIconSvg);
export const FinancesIconTag = createTopicIcon(FinancesIconTagSvg);
export const SchoolIcon = createTopicIcon(SchoolIconSvg);
export const MedicalIcon = createTopicIcon(MedicalIconSvg);
export const OverwhelmIcon = createTopicIcon(OverwhelmIconSvg);
export const CaregivingIcon = createTopicIcon(CaregivingIconSvg);
export const FaithIcon = createTopicIcon(FaithIconSvg);
